<template lang="pug">
  .container.fields-preview
    label.challenge-label Field challenges
    lei-info-label(v-if="parsedFields.length===0" type="warning" text="Nothing was challenged!")
    challenge-preview-section(
      v-for="section in sections"
      :key="section.title"
      :title="section.title"
      :fields="section.fields")
</template>
<script>
import { mapState, } from 'vuex'
import { getFieldByPath, } from '../../utils/challenge'
import RowCreator from '@/components/record-details/table-components/RowCreator'
import LeiInfoLabel from '@/components/lei-components/LeiInfoLabel'
import ChallengePreviewSection from '@/components/challenge-components/ChallengePreviewSection'

export default {
  components: {
    ChallengePreviewSection,
    LeiInfoLabel,
    RowCreator,
  },
  computed: {
    sections () {
      return [
        {
          title: 'Reference Data: Entity',
          fields: this.refEntitySection,
        },
        {
          title: 'Reference Data: Legal address',
          fields: this.refAddressesLegalSection,
        },
        {
          title: 'Reference Data: Headquarters address',
          fields: this.refAddressesHeadquartersSection,
        },
        {
          title: 'Reference Data: Other addresses',
          fields: this.refAddressesOtherSection,
        },
        {
          title: 'Reference Data: Registration',
          fields: this.refRegistrationSection,
        },
        {
          title: 'Relationship Data: Direct Parent Relationship Details',
          fields: this.relEntityRelSection('directParent'),
        },
        {
          title: 'Relationship Data: Direct Parent Registration Details',
          fields: this.relEntityRegSection('directParent'),
        },
        {
          title: 'Relationship Data: Ultimate Parent Relationship Details',
          fields: this.relEntityRelSection('ultimateParent'),
        },
        {
          title: 'Relationship Data: Ultimate Parent Registration Details',
          fields: this.relEntityRegSection('ultimateParent'),
        },
        {
          title: 'Relationship Data: Fund Manager Relationship Details',
          fields: this.relEntityRelSection('fundManager'),
        },
        {
          title: 'Relationship Data: Fund Manager Registration details',
          fields: this.relEntityRegSection('fundManager'),
        },
        {
          title: 'Relationship Data: Umbrella Fund Relationship details',
          fields: this.relEntityRelSection('umbrellaFund'),
        },
        {
          title: 'Relationship Data: Umbrella Fund Registration details',
          fields: this.relEntityRegSection('umbrellaFund'),
        },
        {
          title: 'Relationship Data: Master Fund Relationship details',
          fields: this.relEntityRelSection('masterFund'),
        },
        {
          title: 'Relationship Data: Master Fund Registration details',
          fields: this.relEntityRegSection('masterFund'),
        },
        {
          title: 'Relationship Data: Head Office Relationship details',
          fields: this.relEntityRelSection('headOffice'),
        },
        {
          title: 'Relationship Data: Head Office Registration details',
          fields: this.relEntityRegSection('headOffice'),
        },
        {
          title: 'High Level Data',
          fields: this.highLevelSection,
        },
      ]
    },
    refEntitySection () {
      return this.parsedFields.filter((f) => f.jsonPath.startsWith('$.entity') || f.jsonPath === '$.bic')
    },
    refAddressesLegalSection () {
      return this.parsedFields.filter((f) => f.jsonPath.startsWith('$.legalAddress'))
    },
    refAddressesHeadquartersSection () {
      return this.parsedFields.filter((f) => f.jsonPath.startsWith('$.headquartersAddress'))
    },
    refAddressesOtherSection () {
      return this.parsedFields.filter((f) => f.jsonPath.startsWith('$.addresses'))
    },
    refRegistrationSection () {
      return this.parsedFields.filter((f) => f.jsonPath.startsWith('$.registration'))
    },
    highLevelSection () {
      return this.parsedFields.filter((f) => f.jsonPath === '$.lei')
    },
    parsedFields () {
      return this.fields.map(({ comment, field, jsonPath, proposed_value: newValue, original_value: oldValue, }) => {
        return {
          comment,
          oldValue,
          newValue,
          field,
          ...getFieldByPath(this.getUniqueJsonPath(jsonPath)),
        }
      })
    },

    ...mapState('record/challenge', [ 'challenge', 'fields', ]),
  },

  methods: {
    getUniqueJsonPath (path) {
      if (path.indexOf('successorEntities') !== -1 || path.indexOf('otherValidationAuthorities') !== -1) {
        return path.replace(/\[(.+?)]/g, '[*]')
      }
      return path
    },
    relEntityRelSection (relation) {
      return this.parsedFields.filter((f) => {
        return f.jsonPath.startsWith(`$.${relation}.info`)
            || f.jsonPath.startsWith(`$.${relation}.periods`)
            || f.jsonPath.startsWith(`$.${relation}.exception`)
      })
    },
    relEntityRegSection (relation) {
      return this.parsedFields.filter((f) => f.jsonPath.startsWith(`$.${relation}.registration`))
    },
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .fields-preview
    flex-direction column
</style>



// WEBPACK FOOTER //
// src/components/challenge-components/ChallengePreview.vue